// eslint-disable-next-line no-restricted-imports
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { AppState } from 'bootstrap.store';

/** Represents a typed selector hook. */
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
